import React from 'react';
import { REACT_APP_API_URL } from "../env.js";
import {
    formatDate,
    formatTime,
    formatDateTime,
    getMeetingStatus
} from "../utils/tenderHelpers";
import styles from "./Tenders.module.css";

const TendersMobileCard = ({ tenders, currentDate }) => {
    return (
        <div className="d-md-none">
            {tenders.map((t, idx) => {
                return (
                    <div className="card mb-3" key={idx}>
                        <div className="card-body">
                            <h5 className="card-title">
                                <span className="badge bg-secondary me-2">{idx + 1}</span>
                                {t.Title}
                                {new Date(t.ClosingDate) > currentDate && (
                                    <span
                                        className={`${styles.latestBadge} ms-2`}
                                        aria-label="Latest Tender"
                                        title="Latest Tender"
                                    >
                                        New
                                    </span>
                                )}
                            </h5>
                            <p>
                                <strong>Tender No:</strong> {t.TenderNo}
                            </p>
                            <p>
                                <strong>Bid Closing Date & Time:</strong>{" "}
                                {formatDateTime(t.ClosingDate, t.ClosingTime)}
                            </p>
                            <p>
                                <strong>Bid Opening Date & Time:</strong>{" "}
                                {formatDateTime(t.OpeningDate, t.OpeningTime)}
                            </p>
                            <div className="d-flex flex-wrap gap-2 mt-2">
                                {[
                                    "RFP",
                                    "Notice",
                                    "PreBid",
                                    "Corrigendum",
                                ].map((key) => (
                                    <div key={key}>
                                        {t[key]
                                            ? t[key]
                                                .split("||")
                                                .filter((p) => p.trim() !== "")
                                                .map((p, i) => (
                                                    <a
                                                        key={`${key}-${i}`}
                                                        href={`${REACT_APP_API_URL}/Tender/${p}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className={`btn btn-sm btn-outline-primary me-1 mb-1 ${styles.btnSm}`}
                                                    >
                                                        {key} {i + 1}
                                                    </a>
                                                ))
                                            : ""}
                                    </div>
                                ))}
                                {[...(t.Supporting?.split("||") || []), ...(t.Query?.split("||") || [])]
                                    .filter(p => p.trim() !== "")
                                    .map((p, i) => (
                                        <a
                                            key={`SQ-${i}`}
                                            href={`${REACT_APP_API_URL}/Tender/${p}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className={`btn btn-sm btn-outline-primary ${styles.btnSm}`}
                                        >
                                            Doc {i + 1}
                                        </a>
                                    ))}
                            </div>
                            {(() => {
                                const status = getMeetingStatus(t.MeetingDate, t.MeetingTime);

                                if (status === "ENDED" || status === "NO_MEETING") return null;

                                if (status === "COMING_SOON") {
                                    return (
                                        <p className="text-warning fw-bold mt-2">
                                            Coming Soon<br />
                                            <small className="text-muted">
                                                {formatDate(t.MeetingDate)} | {formatTime(t.MeetingTime)}
                                            </small>
                                        </p>
                                    );
                                }
                                return (
                                    <div className="mt-2">
                                        <a
                                            href={t.MeetingLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            className={`btn btn-sm btn-success ${styles.btnSm}`}
                                        >
                                            Join Meeting
                                        </a>
                                        <br />
                                        <small className="text-muted">
                                            {formatDate(t.MeetingDate)} | {formatTime(t.MeetingTime)}
                                        </small>
                                    </div>
                                );
                            })()}

                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TendersMobileCard;
